import get from 'lodash/get';
import has from 'lodash/has';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';

export const stripJson = jsonStr => (
    !isNil(jsonStr)
        ? jsonStr
            .replace(/\[\d]|["}{]|\[|]/g, '')
            .replace(/[.:,]/g, ' ')
            .replace(/\s{2}/g, ' ')
            .trim()
        : ''
);
// todo: could be moved to productDetail.component
export const hasDuplicateVariantSku = msg => (
    !isNil(msg) && msg.match(/.*ProductVariantSkuUniqueIndex.*/gi) !== null
);

export const hasMissingData = msg => (
    !isNil(msg) && msg.match(/.*must have a non-empty value.*|.*must contain values.*/gi) !== null
);

export const extractModelStateMessage = resp => (
    has(resp, 'data.modelState')
        ? stripJson(JSON.stringify(resp.data.modelState))
        : ''
);

export const extractItemsMessage = resp => (
    has(resp, 'data.items[0].message')
        ? stripJson(resp.data.items[0].message)
        : ''
);

export const extractMessageFromResponse = resp => (
    has(resp, 'data.message')
        ? `${get(resp, 'data.message', '')} ${extractModelStateMessage(resp)}`
        : extractItemsMessage(resp)
);

export const extractDetailErrMessage = err => (
    (err instanceof Error)
        ? err.message
        : extractMessageFromResponse(err)
);

export const getDescriptionTranslationKey = (errMsg) => {
    if (hasDuplicateVariantSku(errMsg)) {
        return 'ERROR.VARIANT_DUPLICATE_SKU_CONFLICT';
    }
    if (hasMissingData(errMsg)) {
        return 'ERROR.GENERAL_MISSING_REQUIRED_DATA';
    }
    return 'ERROR.GENERAL_DESCRIPTION';
};

export const GeneralErrorHandlerServiceModule = angular
    .module('vln.utilities.generalErrorHandler', [
        'ngRaven',
        'ngMaterial'
    ])
    .factory('generalErrorHandlerService', ($mdDialog, $translate, Raven) => {
        function _showGeneralErrorDialog(errMsg, descriptionKey) {
            return function(translations) {
                const errMessage = isEmpty(errMsg)
                    ? translations[descriptionKey]
                    : `${translations[descriptionKey]}<br/><br/>Details:<br/>${errMsg}`;
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(false)
                        .title(translations['ERROR.GENERAL_TITLE'])
                        .htmlContent(errMessage)
                        .ariaLabel(translations['ERROR.GENERAL_TITLE'])
                        .ok(translations['ERROR.GENERAL_OK_BUTTON'])
                        .multiple(false)
                );
            };
        }

        function alertUser(err) {
            Raven.captureException(err);
            const errMsg = extractDetailErrMessage(err);
            const descriptionKey = getDescriptionTranslationKey(errMsg);
            const showGeneralErrDialog = _showGeneralErrorDialog(errMsg, descriptionKey);
            return $translate([
                'ERROR.GENERAL_TITLE',
                descriptionKey,
                'ERROR.GENERAL_OK_BUTTON'])
                .then(showGeneralErrDialog);
        }

        return {
            alertUser
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/utilities/generalErrorHandler.service.js